import AboutComponent from "@components/About";
import CallToSignUp from "@components/CallToSignUp";
import Footer from "@components/Footer";
import Header from "@components/Header";
import SeoHead from "@components/SeoHead";
import ZohoChatWidget from "@components/ZohoChatWidget";
import { useGenzoTracking } from "@context/tracking/genzo";
import withSiteConfig, { getSiteConfig } from "@context/withSiteConfig";
import withTranslations, { getTranslations } from "@context/withTranslations";
import { getAboutPageView } from "@helpers/genzo/genzoPageViewBuilders";
import type { GetServerSideProps, NextPage } from "next";
import { useEffect } from "react";

const About: NextPage = () => {
  const { trackPageView } = useGenzoTracking();

  useEffect(() => {
    trackPageView(getAboutPageView());
  }, []);

  return (
    <>
      <SeoHead page="about" />
      <ZohoChatWidget />
      <Header />
      <AboutComponent />
      <CallToSignUp />
      <Footer />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const env = process.env.APP_ENV;
  const siteConfig = getSiteConfig(context, env);
  const translations = await getTranslations(siteConfig);

  return { props: { siteConfig, translations } };
};

export default withTranslations(withSiteConfig(About));
